import React from 'react';

import { graphql } from 'gatsby';

import { CostItem, CostSection } from '@mewa/ui';

import { StrapiComponentType } from '../types';
import { Description, TextContainer } from './mewa-essentials';
import { MewaEssentialsSection } from './types';

export const CostsFragment = graphql`
  fragment CostsFragment on STRAPI__COMPONENT_MEWA_ESSENTIALS_COSTS {
    tabTitle
    description
    costItems {
      headline
      description {
        data {
          childMarkdownRemark {
            html
          }
        }
      }
    }
    strapi_component
  }
`;

export const componentName = 'mewa-essentials.costs';

export type CostsData = StrapiComponentType<typeof componentName> & {
  description: string;
  costItems: CostItem[];
};

export const isCosts = (
  component: MewaEssentialsSection,
): component is MewaEssentialsSection<CostsData> => {
  return component.strapi_component === componentName;
};

export const StrapiCosts = ({ data }: { data: CostsData }) => {
  return (
    <>
      <TextContainer>
        <Description>{data.description}</Description>
      </TextContainer>

      <CostSection items={data.costItems} />
    </>
  );
};
